// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_InternalParameterId.eqInternalParameterId);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var compare = /* #__PURE__ */ Data_Ord.compare(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId);
var InternalParameterIsSymbol = {
    reflectSymbol: function () {
        return "InternalParameter";
    }
};
var CustomParameterIsSymbol = {
    reflectSymbol: function () {
        return "CustomParameter";
    }
};
var InternalParameter = /* #__PURE__ */ (function () {
    function InternalParameter(value0) {
        this.value0 = value0;
    };
    InternalParameter.create = function (value0) {
        return new InternalParameter(value0);
    };
    return InternalParameter;
})();
var CustomParameter = /* #__PURE__ */ (function () {
    function CustomParameter(value0) {
        this.value0 = value0;
    };
    CustomParameter.create = function (value0) {
        return new CustomParameter(value0);
    };
    return CustomParameter;
})();
var toFillFormTypeParameterId = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqParameterId = {
    eq: function (x) {
        return function (y) {
            if (x instanceof InternalParameter && y instanceof InternalParameter) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof CustomParameter && y instanceof CustomParameter) {
                return eq1(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var ordParameterId = {
    compare: function (x) {
        return function (y) {
            if (x instanceof InternalParameter && y instanceof InternalParameter) {
                return compare(x.value0)(y.value0);
            };
            if (x instanceof InternalParameter) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof InternalParameter) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof CustomParameter && y instanceof CustomParameter) {
                return compare1(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ParameterId (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqParameterId;
    }
};
var genericParameterId = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new InternalParameter(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new CustomParameter(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ParameterId (line 17, column 1 - line 17, column 77): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof InternalParameter) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CustomParameter) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.ParameterId (line 17, column 1 - line 17, column 77): " + [ x.constructor.name ]);
    }
};
var showParameterId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericParameterId)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_InternalParameterId.showInternalParameterId))(InternalParameterIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(CustomParameterIsSymbol)))
};
var unscrambleDecodeParameterId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericParameterId)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(InternalParameterIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_InternalParameterId.unscrambleDecodeInternalParameterId)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(CustomParameterIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)))))(Unscramble_Generic.defaultOptions)
};
var ufromJSONKeyParameterId = {
    fromJSONKey: /* #__PURE__ */ Unscramble.defaultFromJSONKeyValue(unscrambleDecodeParameterId)
};
var encodeParameterId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericParameterId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InternalParameterIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_InternalParameterId.encodeInternalParameterId))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CustomParameterIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))))
};
var decodeParameterId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericParameterId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InternalParameterIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_InternalParameterId.decodeInternalParameterId)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CustomParameterIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var asJSONKeyParameterId = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyValue(Foreign_Generic_Class.encode(encodeParameterId), Foreign_Generic_Class.decode(decodeParameterId))
    };
})();
export {
    InternalParameter,
    CustomParameter,
    genericParameterId,
    eqParameterId,
    showParameterId,
    asJSONKeyParameterId,
    ufromJSONKeyParameterId,
    ordParameterId,
    encodeParameterId,
    decodeParameterId,
    unscrambleDecodeParameterId,
    toFillFormTypeParameterId
};
